import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import EmergencyCTA from "@/components/EmergencyCTA";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import Estimate from "@/components/Estimate";
import Footer from "@/components/Footer";

export default function Home({ loading }) {
  const start = !loading;
  return (
    <main data-testid="home-page" className="bg-black">
      <Nav show={start} />
      <Hero start={start} />
      <EditorialMarquee />
      <Manifesto />
      <Services />
      <EmergencyCTA />
      <Gallery />
      <Testimonials />
      <Estimate />
      <Footer />
    </main>
  );
}
